import { render, staticRenderFns } from "./OptionsAfterImportAccountToCampaign.vue?vue&type=template&id=6489d5eb&scoped=true"
import script from "./OptionsAfterImportAccountToCampaign.vue?vue&type=script&lang=js"
export * from "./OptionsAfterImportAccountToCampaign.vue?vue&type=script&lang=js"
import style0 from "./OptionsAfterImportAccountToCampaign.vue?vue&type=style&index=0&id=6489d5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489d5eb",
  null
  
)

export default component.exports